<template>
  <div class="bill-templates-page">
    <div class="bill-templates__content">
      <div class="bill-templates__header">
        <div class="bill-templates__title">
          {{ $t('bill-templates.list.title') }}
        </div>
        <require-access action="read" data="bills-template-make_template">
          <primary-button
            :label="$t('bill-templates.actions.create')"
            @click="goToCreateTemplate"
          ></primary-button>
        </require-access>
      </div>

      <div class="bill-templates__list">
        <bill-template
          :company-id="selectedCompany"
          class="bill-templates__item"
          v-for="template in activeTemplates"
          :template="template"
          :key="`template-${template.TemplateID}`"
          @deleted="handleTemplateDeleted(template)"
          @click="createBillByTemplate(template)"
        ></bill-template>
      </div>
    </div>

    <!-- POPUP / NOTIFICATIONS    -->
    <bill-deleted-notification
      ref="billDeletedNotification"
    ></bill-deleted-notification>
  </div>
</template>

<script>
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import BillTemplate from '@vue-app/components/company/bills/BillTemplate.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import BillDeletedNotification from '@vue-app/components/company/bills/popup/notification/BillDeletedNotification.vue'
import { mapState } from 'vuex'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'BillTemplatesPage',
  props: ['id'],
  components: {
    RequireAccess,
    BillDeletedNotification,
    NoBgButton,
    PrimaryButton,
    BillTemplate,
    ArrowButton,
  },
  data() {
    return {
      templates: [],
    }
  },
  computed: {
    ...mapState(['selectedCompany']),
    activeTemplates() {
      return this.templates.filter((_t) => _t.Act === true)
    },
  },
  created() {
    this.loadTemplates()
  },
  methods: {
    handleTemplateDeleted(template) {
      this.templates.splice(
        this.templates.findIndex((_t) => _t.TemplateID === template.TemplateID),
        1
      )

      this.$refs.billDeletedNotification.show()
    },
    createBillByTemplate(template) {
      this.$router.push(
        RouteHelper.getRoute('bill-template-view', {
          companyId: this.selectedCompany,
          templateId: template.TemplateID,
        })
      )
    },
    goToCreateTemplate() {
      this.$router.push(
        RouteHelper.getRoute('bill-create-template', {
          companyId: this.selectedCompany,
        })
      )
    },
    async loadTemplates() {
      let _templatesResponse = await CompaniesApi.getBillsTemplates(
        this.selectedCompany
      )
      this.templates = _templatesResponse.data
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--bill-templates {
    padding-top: 28px;
  }

  &__header {
    margin-bottom: 24px;
  }
}
.bill-templates {
  &__content {
    margin-top: 31px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #465a8b;
    margin-left: 50px;
  }

  &__list {
    margin-top: 34px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 18px;
    row-gap: 18px;
  }
}
</style>
